/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  StandardError,
  User
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Disconnect OAuth provider
 */
export const disconnectOauthProvider = (
    provider: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      provider = toValue(provider);

      return axiosClient<User>(
      {url: `/omniauth-connections/${provider}`, method: 'DELETE', signal
    },
      );
    }




export const getDisconnectOauthProviderMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectOauthProvider>>, TError,{provider: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disconnectOauthProvider>>, TError,{provider: string}, TContext> => {

const mutationKey = ['disconnectOauthProvider'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectOauthProvider>>, {provider: string}> = (props) => {
          const {provider} = props ?? {};

          return  disconnectOauthProvider(provider,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectOauthProviderMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectOauthProvider>>>

    export type DisconnectOauthProviderMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Disconnect OAuth provider
 */
export const useDisconnectOauthProvider = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectOauthProvider>>, TError,{provider: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disconnectOauthProvider>>,
        TError,
        {provider: string},
        TContext
      > => {
      return useMutation(getDisconnectOauthProviderMutationOptions(options), queryClient);
    }
